export default __webpack_public_path__ + "static/python-basics-d98a33ef0fe54d7ca91ac97be9f1324f.webp";